import { Framework } from '@flint/framework';
import { authProvider } from "./authProvider";

export default class AuthInterceptor {

  handleResponse = (error, response) => {
    if (error) {
      return Promise.reject(error);
    } else if (response) {
      switch (response.status) {
        case 401: {
          Framework.redirect('/errors/HTTP_401');
          return Promise.reject(new Error('Need authentication'));
        }
        case 403:
          Framework.redirect('/errors/HTTP_403');
          return Promise.reject(new Error('Need authorization'));
        default:
          break;
      }
    }
    return response;
  };

  handleRequest = async requestConfig => {
    const token = await authProvider.getAccessToken();
    const config = requestConfig;
    config.headers['Authorization'] = `Bearer ${token.accessToken}`;
    return config;
  };
}